import {
  defaultFdsFiltro,
  defaults,
  defaultSelectedComponente,
  defaultSelectedValorExpo,
  defaultSelectedValorExpoOtros,
  defaultSelectedCarcinogenicidad,
  defaultSelectedTransporte,
  defaultSelectedToxicidad,
  defaultSelectedElementosProteccion
} from './state';

/**
 * Mutación para obtener la acción actual (crear,editar)
 * @param state
 * @param accion
 */
export function setAccion(state, accion) {
  state.accion = accion;
}

/**
 * Mutación para parametrizar otros valores de exposición.
 * @param state
 * @param accion
 */
export function setAccionSelectedValorExpoOtros(state, accion) {
  state.selectedValorExpoOtros.accion = accion;
}

/**
 * Mutación para parametrizar elementos de protección personal.
 * @param state
 * @param accion
 */
export function setAccionSelectedElementosProteccion(state, accion) {
  state.selectedElementosProteccion.accion = accion;
}

/**
 * Mutación para parametrizar el id de empresa.
 * @param state
 * @param id_empresa
 */
export function setIdEmpresaFdsProducto(state, id_empresa) {
  state.id_empresa = id_empresa;
}

/**
 * Mutación para parametrizar el id del producto.
 * @param state
 * @param id_fds_producto
 */
export function setIdFdsProducto(state, id_fds_producto) {
  state.id_fds_producto = id_fds_producto;
}

/**
 * Mutación para parametrizar la sección actual en la que se trabaja.
 * @param state
 * @param numSeccion
 */
export function setSeccionActual(state, numSeccion) {
  state.seccionActual = numSeccion;
}

/**
 * Mutación para parametrizar el tipo de documento.
 * @param state
 * @param tipo_documento
 */
export function setTipoDocumento(state, tipo_documento) {
  state.tipo_documento = tipo_documento;
}

/**
 * Mutación para parametrizar el tipo de documento de sección 1.
 * @param state
 * @param tipo_documento
 */
export function setTipoDocumentoSeccion1(state, tipo_documento) {
  state.selectedSeccion1.tipo_documento = tipo_documento;
}

/**
 * Mutación para parametrizar el id del fabricante del producto.
 * @param state
 * @param id_fabricante
 */
export function setIdFabricante(state, id_fabricante) {
  state.selectedSeccion1.id_fabricante = id_fabricante;
}

/**
 * Mutación para setear el filtro del buscador.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} buscar contiene la información de la busqueda.
 */
 export function setFiltro(state, buscar) {
  state.filtro_fds.page = 1;
  state.filtro_fds = buscar;
}

/**
 * Mutación para reestablecer el filtro del buscador
 * @param {*} state contiene la información de variables del formulario.
 */
export function resetFiltro(state) {
  state.filtro_fds = defaultFdsFiltro();
}

/**
 * Mutación para cargar la informacion del producto en el buscador de productos.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} productos contieme la información de los productos químicos.
 */
export function setProductosFds(state, productos_fds) {
  if (productos_fds.data.length > 0) {
    state.productos_fds = productos_fds;
  } else {
    state.productos_fds = [];
  }
}

// paginacion
export function setPage(state, page) {
  state.filtro_fds.page = page;
}

//cantidad de registros por pagina
export function setPerPage(state, perPage) {
  state.filtro_fds.page = 1;
  state.filtro_fds.perPage = perPage;
}

/**
 * Mutación para parametrizar las versiones por producto.
 * @param state
 * @param versiones_producto_fds
 */
export function setVersionesProductoFds(state, versiones_producto_fds) {
  if (versiones_producto_fds.length > 0) {
    state.versiones_producto_fds = versiones_producto_fds;
  } else {
    state.versiones_producto_fds = [];
  }
}

/**
 * Mutación para parametrizar información de la sección.
 * @param state
 * @param data
 */
export function setSeccionInfo(state, data) {
  state['selectedSeccion' + state.seccionActual] = data;
}

/**
 * Mutación para reiniciar state de la sección que se está trabajando.
 * @param state
 * @param accion
 */
export function resetSeccion(state, accion = 'crear') {
  state.accion = accion;
  state['selectedSeccion' + state.seccionActual] = defaults()[state.seccionActual];
}

/**
 * Mutación para parametrizar el id de producto dentro de la sección trabajada.
 * @param state
 * @param id_fds_producto
 */
export function setIdFdsProductoSeccion(state, id_fds_producto) {
  state['selectedSeccion' + state.seccionActual].id_fds_producto = id_fds_producto;
}

/**
 * Establecer el valor de una variable de estado de formulario
 * @param state
 * @param data
 */
export function setState(state, data) {
  state[data.parent][data.child] = data.value;
}

// Componentes detalle
/**
 * Parametrizar componentes
 * @param state
 * @param data
 */
export function setSelectedComponente(state, data) {
  state.selectedComponente = data;
}

/**
 * Mutación para reiniciar state de selectedComponente
 * @param state
 */
export function resetSelectedComponente(state) {
  state.selectedComponente = defaultSelectedComponente();
}

/**
 * Mutación para parametrizar componentes detalle.
 * @param state
 * @param data
 */
export function setComponentesDetalle(state, data) {
  state.componentes_detalle = data;
}

// Valores exposición
/**
 * Mutación para parametrizar valores de exposición.
 * @param state
 * @param data
 */
export function setSelectedValorExpo(state, data) {
  state.selectedValorExpo = data;
}

/**
 * Mutación para reiniciar valores de exposición.
 * @param state
 */
export function resetSelectedValorExpo(state) {
  state.selectedValorExpo = defaultSelectedValorExpo();
}

/**
 * Mutación para parametrizar los elementos de protección personal.
 * @param state
 * @param data
 */
export function setSelectedElementosProteccion(state, data) {
  state.selectedElementosProteccion = data;
}

/**
 * Mutación para reiniciar elementos de protección personal.
 * @param state
 */
export function resetSelectedElementosProteccion(state) {
  state.selectedElementosProteccion = defaultSelectedElementosProteccion();
}

/**
 * Mutación para parametrizar los elementos de protección.
 * @param state
 * @param data
 */
export function setElementosProteccion(state, data) {
  state.elementos_proteccion = data;
}

/**
 * Mutación para parametrizar los valores de exposición.
 * @param state
 * @param data
 */
export function setValoresExposicion(state, data) {
  state.valores_exposicion = data;
}

// Valores exposición Otros
/**
 * Mutación para parametrizar los otros valores de exposición.
 * @param state
 * @param data
 */
export function setSelectedValorExpoOtros(state, data) {
  state.selectedValorExpoOtros = data;
}

/**
 * Mutación para reiniciar otros valores de exposición.
 * @param state
 */
export function resetSelectedValorExpoOtros(state) {
  state.selectedValorExpoOtros = defaultSelectedValorExpoOtros();
}

// Carcinogenicidad
/**
 * Mutación para parametrizar grupos de la IARC.
 * @param state
 * @param data
 */
export function setIarcGrupos(state, data) {
  state.iarc_grupos = data;
}

/**
 * Mutación para parametrizar carcinogenicidad.
 * @param state
 * @param data
 */
export function setSelectedCarcinogenicidad(state, data) {
  state.selectedCarcinogenicidad = data;
}

/**
 * Mutación para reiniciar carcinogenicidad.
 * @param state
 */
export function resetSelectedCarcinogenicidad(state) {
  state.selectedCarcinogenicidad = defaultSelectedCarcinogenicidad();
}

/**
 * Mutación para parametrizar carcinogenicidad.
 * @param state
 * @param data
 */
export function setCarcinogenicidades(state, data) {
  state.carcinogenicidades = data;
}

// Toxicidad
/**
 * Mutación para parametrizar animales.
 * @param state
 * @param data
 */
export function setAnimales(state, data) {
  state.animales = data;
}

/**
 * Mutación para parametrizar vias de ingreso.
 * @param state
 * @param data
 */
export function setViasIngreso(state, data) {
  state.vias_ingreso = data;
}

/**
 * Mutación para parametrizar marcadores.
 * @param state
 * @param data
 */
export function setMarcadores(state, data) {
  state.marcadores = data;
}

/**
 * Mutación para obtener toxicidades.
 * @param state
 * @param data
 */
export function setSelectedToxicidad(state, data) {
  state.selectedToxicidad = data;
}

/**
 * Mutación para reiniciar toxicidades.
 * @param state
 */
export function resetSelectedToxicidad(state) {
  state.selectedToxicidad = defaultSelectedToxicidad();
}

/**
 * Mutación para parametrizar toxicidades.
 * @param state
 * @param data
 */
export function setToxicidades(state, data) {
  state.toxicidades = data;
}

/**
 * Mutación para parametrizar componentes FDS.
 * @param state
 * @param data
 */
export function setComponentesFds(state, data) {
  state.componentesFds = data;
}

// Naciones unidas
/**
 * Mutación para parametrizar transporte seleccionado.
 * @param state
 * @param data
 */
export function setSelectedTransporte(state, data) {
  state.selectedTransporte.accion = 'editar';
  state.selectedTransporte.id = data.id;
  state.selectedTransporte.id_empresa = data.id_empresa;
  state.selectedTransporte.id_fds_producto = data.id_fds_producto;
  state.selectedTransporte.tipo_transporte = data.tipo_transporte;
  state.selectedTransporte.noun = data.noun;
  state.selectedTransporte.riesgo_principal = data.riesgo_principal;
  state.selectedTransporte.riesgo_secundario = data.riesgo_secundario;
  state.selectedTransporte.riesgo_secundario1 = data.riesgo_secundario1;
}

/**
 * Muractión para reiniciar transporte.
 * @param state
 */
export function resetSelectedTransporte(state) {
  state.selectedTransporte = defaultSelectedTransporte();
}

/**
 * Mutación para parametrizar detalle de transportes.
 * @param state
 * @param data
 */
export function setTransportesDetalle(state, data) {
  state.naciones_unidas = data;
}

/**
 * Mutación para parametrizar el tipo de peligros.
 * @param state
 * @param tipo_peligro
 */
export function setTipoPeligro(state, tipo_peligro) {
  state.tipo_peligro = tipo_peligro;
}

/**
 * Mutación para parametrizar el tipo de toxicidad.
 * @param state
 * @param tipo_toxicidad
 */
export function setTipoToxicidad(state, tipo_toxicidad) {
  state.tipo_toxicidad = tipo_toxicidad;
}

/**
 * Mutación para sugerencias de CAS.
 * @param state
 * @param data
 */
export function prepareSugerenciaCas(state, data) {
  if (state.tipo_peligro === 'TLV') {
    state.selectedValorExpo = {
      id: null,
      accion: 'crear',
      id_fds_producto: null,
      id_empresa: null,
      componente: data.componente,
      twa_acgih_rango: null,
      twa_acgih: data.acgih_twa,
      twa_acgih_hasta: null,
      id_um_twa_acgih: data.acgih_twa_simbol,
      twa_acgih_observacion: '',
      stel_acgih_rango: null,
      stel_acgih: data.acgih_stel,
      stel_acgih_hasta: null,
      id_um_stel_acgih: data.acgih_stel_simbol,
      stel_acgih_observacion: '',
    }
  } else if (state.tipo_peligro === 'IARC') {
    state.selectedCarcinogenicidad = {
      id: null,
      accion: 'crear',
      id_fds_producto: null,
      id_empresa: null,
      componente: data.componente,
      id_grupo: data.id_grupo,
    };
  }
}

/**
 * Mutación para paramterizar los tipos de transporte.
 * @param state
 * @param data
 */
export function setTiposTransporte(state, data) {
  state.tipos_transporte_list = data;
}
